import React from 'react';
import classnames from 'classnames';
import './SearchDayAlertNightCount.less';
import {useComponent} from './hooks/useComponent';

function SearchDayAlertNightCount(props) {
    const {
        message,
        isMobile
    } = useComponent(props);

    const calendarAlertClasses = classnames('SearchDayAlertNightCount', {
        'SearchDayAlertNightCount--not-mobile': !isMobile,
        'SearchDayAlertNightCount--mobile': isMobile,
        'SearchDayAlertNightCount--empty': !message,
    });

    return (
        <div className={calendarAlertClasses}>
            <div className="InlineMessage">
                <span className="InlineMessageStateless__message InlineMessageStateless__message--same-message">
                    {message}
                </span>
            </div>
        </div>
    );
}

export default SearchDayAlertNightCount;